/*
 * selectors.js
 *
 * Selectors provide different views of state.
 */
import queryString from "query-string";
import { createSelector } from "reselect";

const status = {
  app: {},
  snap: {}
};

status.app.version = state => ((state.status || {}).version || {}).app;

status.snap.version = state =>
  (((state.status || {}).version || {}).snap || {}).version;

status.snap.revision = state =>
  (((state.status || {}).version || {}).snap || {}).revision;

const notifications = {};

notifications.getAll = state => state.notifications.items;

const errors = {};

errors.getForStatus = state => {
  if (state.status.error) {
    return {
      error: state.status.error,
      description: state.status.errorDescription
    };
  }
  return undefined;
};

errors.getForUser = state => {
  if (state.user.error) {
    return {
      error: state.user.error,
      description: state.user.errorDescription
    };
  }
  return undefined;
};

errors.getForPolicies = state => {
  if (state.policies.error) {
    return {
      error: state.policies.error,
      description: state.policies.errorDescription
    };
  }
  return undefined;
};

errors.getAll = createSelector(
  [errors.getForUser, errors.getForStatus, errors.getForPolicies],
  (userError, statusError, policyError) =>
    [userError, statusError, policyError].filter(i => i)
);

const router = {};

router.currentPath = state => state.router.location.pathname;
router.getSearch = state => queryString.parse(state.router.location.search);

export {
  status as statusSelectors,
  notifications as notificationsSelectors,
  errors as errorsSelectors,
  router as routerSelectors
};
